import React from "react";
import { Col, Row, Button, Form } from "react-bootstrap";
import {
  getBillingSettingAction,
  updateBillingSettingAction,
  updateAiModelSettingAction,
} from "./../../actions/UserActions";
import { getApplicationData } from "./../../actions/BillingActions";
import * as code from "./../../config/Constants";
import { connect } from "react-redux";
import { toastMessage } from "../Common/Common";

class PlanSetting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: true,
      isBillingEnabled: true,
      aiModel: "majimeai",
    };
  }

  componentDidMount() {
    this.billingSettingAction();
    this.getapplicationData();
  }

  /** get stripe setting */
  billingSettingAction() {
    this.props.getBillingSettingAction().then((res) => {
      this.setState({ showLoader: false });
      if (res.status === code.OK) {
        this.setState({
          isBillingEnabled:
            (res && res.data && res.data.isBillingEnabled) || true,
        });
      }
    });
  }

  getapplicationData() {
    this.props.getApplicationData().then((result) => {
      if (Array.isArray(result.data) && result.data.length > 0) {
        result.data.map((item) => {
          if (item.name === code.APPICATION_NAME) {
            this.setState({ aiModel: item.aiModel || "majimeai" });
          }
        });
      }
    });
  }

  /** update stripe flag */
  updateBillingSetting() {
    this.setState({ showLoader: true });
    var data = {
      isBillingEnabled: this.state.isBillingEnabled,
      applicationName: code.APPICATION_NAME,
    };
    this.props.updateBillingSettingAction(data).then((res) => {
      // console.log(res);
      this.setState({ showLoader: false });
      if (res.status === code.OK) {
        if (this.state.isBillingEnabled) {
          localStorage.setItem("isBillingEnabled", "true");
        } else {
          localStorage.setItem("isBillingEnabled", "false");
        }
        // window.location.reload(false);
        toastMessage(code.SUCCESS, res.data);
      }
    });
  }

  /** update ai model flag */
  updateAiModelSetting() {
    this.setState({ showLoader: true });
    var data = {
      aiModel: this.state.aiModel,
      applicationName: code.APPICATION_NAME,
    };
    this.props.updateAiModelSettingAction(data).then((res) => {
      // console.log(res)
      this.setState({ showLoader: false });
      if (res.status === code.OK) {
        toastMessage(code.SUCCESS, res.data);
      }
    });
  }

  render() {
    if (this.state.showLoader) {
      return (
        <div className="page-loader fixed">
          <div className="page-loader-inner">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <>
          <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
            <Col className="col-auto">
              <h4 className="title-med mt-0 pt-1">Settings</h4>
            </Col>
          </Row>
          <div className="admin-content-area single">
            <Form>
              <div className="notification-setting">
                {/* <Row className="form-group align-items-center">
                  <Col className="col-auto">
                    <h4>Stripe</h4>
                  </Col>

                  <Col className="pl-0">
                    <div className="custom-control custom-control-inline custom-radio">
                      <input
                        type="radio"
                        className="custom-control-input"
                        name={"radioObject.enable"}
                        key={"radioObject"}
                        checked={this.state.isBillingEnabled === true}
                        id={"displayMessageEnable"}
                        onChange={(e) => {
                          this.setState({
                            isBillingEnabled: !this.state.isBillingEnabled,
                          });
                        }}
                        value={true}
                      />
                      <label
                        title=""
                        for={"displayMessageEnable"}
                        className="custom-control-label"
                      >
                        Enable
                      </label>
                    </div>
                    <div className="custom-control custom-control-inline custom-radio">
                      <input
                        type="radio"
                        className="custom-control-input"
                        value={false}
                        id={"displayMessageDisable"}
                        key={"radioObjectdisable"}
                        name={"radioObject.enable"}
                        checked={this.state.isBillingEnabled === false}
                        onChange={(e) => {
                          this.setState({
                            isBillingEnabled: !this.state.isBillingEnabled,
                          });
                        }}
                      />

                      <label
                        title=""
                        for={"displayMessageDisable"}
                        className="custom-control-label"
                      >
                        Disable
                      </label>
                    </div>
                  </Col>
                </Row>

                <Row className="form-group pt-4">
                  <Col>
                    <Button
                      type="submit"
                      variant="primary"
                      className="btn-blue w-90 font-14 mr-3"
                      onClick={() => {
                        this.updateBillingSetting();
                      }}
                    >
                      Save
                    </Button>
                    <Button
                      variant="primary"
                      className="btn-blue btn-outlined w-90 font-14"
                      onClick={() => this.props.history.goBack()}
                    >
                      Cancel
                    </Button>
                  </Col>
                </Row> */}

                <Row className="form-group align-items-center">
                  <Col className="col-auto">
                    <h4>AI Model</h4>
                  </Col>

                  <Col className="pl-0">
                    <div className="custom-control custom-control-inline custom-radio">
                      <input
                        type="radio"
                        className="custom-control-input"
                        name={"majimeai.enable"}
                        key={"majimeaiEnable"}
                        checked={this.state.aiModel === "majimeai"}
                        id={"majimeaiEnable"}
                        onChange={(e) => {
                          this.setState({
                            aiModel: "majimeai",
                          });
                        }}
                        value={"majimeai"}
                      />
                      <label
                        title=""
                        for={"majimeaiEnable"}
                        className="custom-control-label"
                      >
                        Majime AI
                      </label>
                    </div>
                    <div className="custom-control custom-control-inline custom-radio">
                      <input
                        type="radio"
                        className="custom-control-input"
                        value={"openai"}
                        id={"openaiEnable"}
                        key={"openaiEnable"}
                        name={"openai.enable"}
                        checked={this.state.aiModel === "openai"}
                        onChange={(e) => {
                          this.setState({
                            aiModel: "openai",
                          });
                        }}
                      />

                      <label
                        title=""
                        for={"openaiEnable"}
                        className="custom-control-label"
                      >
                        Open AI
                      </label>
                    </div>
                  </Col>
                  {/* </Row>

                <Row className="form-group pt-4"> */}
                  <Col>
                    <Button
                      type="submit"
                      variant="primary"
                      className="btn-blue w-90 font-14 mr-3"
                      onClick={() => {
                        this.updateAiModelSetting();
                      }}
                    >
                      Save
                    </Button>
                    <Button
                      variant="primary"
                      className="btn-blue btn-outlined w-90 font-14"
                      onClick={() => this.props.history.goBack()}
                    >
                      Cancel
                    </Button>
                  </Col>
                </Row>
              </div>
            </Form>
          </div>
        </>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {};
};
export default connect(
  mapStateToProps,
  {
    getBillingSettingAction,
    updateBillingSettingAction,
    updateAiModelSettingAction,
    getApplicationData,
  }
)(PlanSetting);
